function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import AlignTarget from "./AlignTarget";
const Line = ({
  strategy,
  width = 2000
}) => {
  return /*#__PURE__*/React.createElement(AlignTarget, {
    strategy: strategy,
    lineHeight: 1
  }, alignProps => /*#__PURE__*/React.createElement("div", _extends({}, alignProps, {
    className: "TypeLine"
  }), /*#__PURE__*/React.createElement("div", {
    className: "TypeLine-inner",
    style: {
      left: `${width / -2}px`,
      right: `${width / -2}px`
    }
  })));
};
export default Line;